import axios from "axios";
// import swal from "sweetalert";
import Swal from "sweetalert2";
import {
  loginConfirmedAction,
  Logout,
  authCheckedAction,
} from "../store/actions/AuthActions";
import api from "./ApiUrl";
import { decodeToken } from "../utils/authUtils";
import { profileDetails } from "./academicService";

export function signUp(email, password) {
  //axios call
  const postData = {
    email,
    password,
    returnSecureToken: true,
  };
  return axios.post(
    `https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyD3RPAp3nuETDn9OQimqn_YF6zdzqWITII`,
    postData,
  );
}

export function login(email, password) {
  const postData = {
    email,
    password,
    returnSecureToken: true,
  };
  return api.post(`/tenant/v1/api/authKeyClock/getToken`, postData);
}

export function formatError(errorResponse) {
  switch (errorResponse?.error?.message) {
    case "EMAIL_EXISTS":
      //return 'Email already exists';
      // swal("Oops", "Email already exists", "error");
      Swal.fire({
        icon: "error",
        title: "Oops",
        text: "Email already exists",
      });
      break;
    case "EMAIL_NOT_FOUND":
      Swal.fire({
        icon: "error",
        title: "Oops",
        text: "Email not found",
      });
      //return 'Email not found';
      //swal("Oops", "Email not found", "error",{ button: "Try Again!",});
      break;
    case "INVALID_PASSWORD":
      //return 'Invalid Password';
      // swal("Oops", "Invalid Password", "error",{ button: "Try Again!",});
      Swal.fire({
        icon: "error",
        title: "Oops",
        text: "Invalid Password",
      });
      break;
    case "USER_DISABLED":
      return "User Disabled";

    default:
      return "";
  }
}

export function saveTokenInLocalStorage(tokenDetails) {
  tokenDetails.expireDate = new Date(
    new Date().getTime() + tokenDetails.expires_in * 1000,
  );
  localStorage.setItem("userDetails", JSON.stringify(tokenDetails));
}

export function runLogoutTimer(dispatch, timer, navigate) {
  setTimeout(() => {
    //dispatch(Logout(history));
    dispatch(Logout(navigate));
  }, timer);
}

// export function checkAutoLogin(dispatch, navigate) {
//   const tokenDetailsString = localStorage.getItem("userDetails");
//   let tokenDetails = "";
//   if (!tokenDetailsString) {
//     // Don't navigate here, just mark auth as checked
//     dispatch(authCheckedAction());
//     return;
//   }

//   tokenDetails = JSON.parse(tokenDetailsString);
//   let expireDate = new Date(tokenDetails.expireDate);
//   let todaysDate = new Date();

//   if (todaysDate > expireDate) {
//     // Token expired, logout but don't navigate
//     localStorage.removeItem("userDetails");
//     dispatch(authCheckedAction());
//     return;
//   }

//   const dec = decodeToken(tokenDetails.access_token);
//   console.log("token parse", dec);

//   if (dec) {
//     // Restore authentication state
//     dispatch(loginConfirmedAction(dec));
//     const timer = expireDate.getTime() - todaysDate.getTime();
//     runLogoutTimer(dispatch, timer, navigate);
//   } else {
//     // Invalid token, remove it
//     localStorage.removeItem("userDetails");
//     dispatch(authCheckedAction());
//   }
// }

export async function checkAutoLogin(dispatch, navigate) {
  const tokenDetailsString = localStorage.getItem("userDetails");

  if (!tokenDetailsString) {
    dispatch(authCheckedAction());
    return;
  }

  const tokenDetails = JSON.parse(tokenDetailsString);

  let expireDate = new Date(tokenDetails.expireDate);
  let todaysDate = new Date();

  if (todaysDate > expireDate) {
    localStorage.removeItem("userDetails");
    dispatch(authCheckedAction());
    return;
  }

  const dec = decodeToken(tokenDetails?.access_token);

  if (dec) {
    try {
      // same as loginAction
      const isSuperAdmin = dec?.realm_access?.roles?.includes("super_admin");

      let role = "";

      if (isSuperAdmin) {
        role = "super-admin";
      } else {
        const user = await profileDetails(tokenDetails?.access_token);

        // role = (
        //   user?.defaultTenant?.admin
        //     ? "admin"
        //     : user?.defaultTenant?.userType || ""
        // ).toLowerCase();

        const tenant = user?.defaultTenant;
        // role = (
        //   tenant?.admin === true || (tenant?.admin === false && tenant?.userType === null)
        //     ? "admin"
        //     : tenant.userType
        // ).toLowerCase();
        if (tenant?.admin === true && tenant?.isSubscription) {
          role = "admin";
        } else if (!tenant?.isSubscription) {
          role = "tenant-admin"; // <-- new role
        } else {
          role = (tenant?.userType || "").toLowerCase();
        }
      }

      dispatch(loginConfirmedAction(dec, role));
      const timer = expireDate.getTime() - todaysDate.getTime();
      runLogoutTimer(dispatch, timer, navigate);
    } catch (error) {
      localStorage.removeItem("userDetails");
      dispatch(authCheckedAction());
    }
  } else {
    localStorage.removeItem("userDetails");
    dispatch(authCheckedAction());
  }
}
